import { useState } from 'react';
import type { FC } from 'react';

import { window } from '../../../../globals';
import { useToggleInternalOrg } from '../../../../hooks/api/organization/useToggleInternalOrg';
import Button from '../../../generic/Button/Button';
import Card from '../../../generic/Card/Card';
import LabeledCheckbox from '../../../generic/Forms/LabeledCheckbox';

const ToggleInternalOrgCard: FC = () => {
  const [shouldSetInternal, setShouldSetInternal] = useState(!!window.user?.organization?.isInternal);

  const { mutate: toggleInternal, isPending } = useToggleInternalOrg(() => {
    // reload the page to reflect the change in the Organization Info card
    window.location.reload();
  });

  const onButtonClick = () => {
    toggleInternal({ flag: shouldSetInternal });
  };

  return (
    <Card isFullWidth padding="medium">
      <Card.Header>Internal Organization</Card.Header>
      <Card.Content>
        <div>
          This will set the isInternal field for this organization.
          <br />
          DO NOT ENABLE THIS FOR CUSTOMER ORGANIZATIONS.
        </div>
        <LabeledCheckbox
          onChange={() => setShouldSetInternal(!shouldSetInternal)}
          label="Internal Organization"
          isChecked={shouldSetInternal}
          isDisabled={isPending}
        />
        <Button onClick={onButtonClick} isDisabled={isPending}>
          Update
        </Button>
      </Card.Content>
    </Card>
  );
};

export default ToggleInternalOrgCard;
